import Code from "../../../components/code";
import { User, Link, Chip } from "@nextui-org/react";

import React from "react";

export const updatesPage = {
  title: "Help and Support",
  sections: [
    {
      id: "updates",
      name: "Updates",
    },
    {
      id: "help",
      name: "Help and Support",
    },
    {
      id: "news",
      name: "News",
    },
  ],
  content: (
    <>
      <section id="author">
        <User
          avatarProps={{
            src: "https://i.ibb.co/zVXk5wqg/image.png",
          }}
          description={
            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Link isExternal href="https://github.com/Frig1" size="sm">
                @Frig1
              </Link>
              <Chip
                color="danger"
                variant="bordered"
                size="sm"
                startContent={
                  <img
                    src="https://img.icons8.com/glyph-neue/64/F25081/user-shield.png"
                    alt="user-shield"
                    style={{ width: 14, height: 14 }}
                  />
                }
              >
                Admin
              </Chip>
            </span>
          }
          name="Elia Frigerio"
        />
        <p style={{ fontSize: "0.9em", color: "#666", marginTop: "8px" }}>
          Published on June 1, 2025 at 13:40 AM
        </p>
      </section>
      <section id="updates">
        <h2>🚀 Updates</h2>
        <p>
          Keep your MEOW CLI purring 🐾 with the latest features and fixes!
          Update your CLI using: <Code fullWidth>meow update</Code>
          <br></br>
          Want to know what version you're on? Check it with:{" "}
          <Code fullWidth>meow version</Code>. ✨
        </p>
      </section>
      <section id="help">
        <h2>📚 Help and Support</h2>
        <p>
          Stuck? Don't fret! 🆘 Access the comprehensive help guide right from
          your terminal: <Code fullWidth>meow help</Code>
        </p>
      </section>
      <section id="news">
        <h2>📣 Exciting News!</h2>
        <div className="news-card">
          <p>
            Big news for our Neko-CLI community! 🎉 We're thrilled to announce
            that <strong>24/7 phone support</strong> will be available starting{" "}
            <strong>September 28, 2026</strong>! 📞
          </p>
          <p className="text-sm text-default-500 mt-2">
            Get ready for round-the-clock assistance whenever you need it. 🕰️
            Stay tuned for more details on the dedicated helpline number. 🔜
          </p>
        </div>
      </section>
    </>
  ),
};


